import React from 'react';
import MessageRow from './MessageRow';
import ToggleNoLabel from '../ToggleNoLabel';

const ToggleRow = ({
  checked,
  collapsing,
  context,
  disabled,
  entity = 'toggle',
  icons = [],
  label,
  labelWidth,
  message,
  onClick,
}) => (
  <MessageRow
    className="aridhia-toggle-row"
    collapsing={collapsing}
    context={context}
    entity={entity}
    icons={icons}
    labelWidth={labelWidth}
    message={message}
  >
    <ToggleNoLabel label={label} onClick={onClick} disabled={disabled} checked={checked} className="float-r" />
  </MessageRow>
);

export default ToggleRow;
